module.exports = function() {
  return new Worker(__webpack_public_path__ + "ecbb8611a28589a55f56.worker.js");
};